import { buildToday } from "./utils";
const defaultStateFactory = () => {
    return {
        period_start_date: buildToday(),
        period_end_date: buildToday(),
        button_selected: 0,
    };
};
export default defaultStateFactory;
